import React, { useState, useEffect } from 'react';
import { postDataFetcher } from '../../../dataFetcher';
import CONFIG_OBJECT from '../../../config/config';
import GenderList from './GenderList'
import Pagination from "react-js-pagination";
import App_Constants from '../../../app-constants/App_Constants';

const NameResults = (props) => {
   
    const [fullData] = useState(props.fullData);
    const [similarBabyNames, setSimilarBabyNames] = useState(props.similarBabyNames);
    const [currentPage, setCurrentPage] = useState(1)

    //Navigate to the page
     const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }

    /* below function called on every pagination click */
    useEffect(() => {
        displayName()
    }, [currentPage])

    const displayName = async (e) => {

        let sTypevalue = "searchbyname"
        let sTermValue = fullData.babyNamesList !== null ? fullData.babyNamesList[0].name : props.searchterm

        let gTypeValue = "";
        if(props.sType !== 'searchbyalphabet'){
            gTypeValue = props.gendertype !== null ? props.gendertype : ''
        } 

        const searchData = {
            searchtype: sTypevalue,
            searchterm: sTermValue,
            gender: gTypeValue,
            pagenumber: currentPage
        }

        return (
            /* REST Api call to get the similar result */
            postDataFetcher(`${CONFIG_OBJECT.BNF_REST_URL}${App_Constants.SC_API_KEY}`,searchData)
            .then(res => {            
                Promise.resolve()
                .then(() => {
                    if(res.data.Data !== null){                        
                        setSimilarBabyNames(res.data.Data.babyNamesResult.similarBabyNamesList)
                        setCurrentPage(currentPage)
                    }
                })
            })
            .catch(err => {
                if (err.response) {
                    // client received an error response (5xx, 4xx)
                    console.log(err.response)                  
                } else if (err.request) {
                    // client never received a response, or request never left
                    console.log(err.request)                  
                } else {
                  // anything else
                  console.log(err)
                }
            })
        )  
    }
        
    if(similarBabyNames !== null){
        return (
            <React.Fragment>                
                <div className="blk blk-name-sim-result table-result">
                    <h4>{fullData.similarNamesTitle}</h4>
                    <table>
                        <thead>
                            <tr>
                                <th className="namecolumn">{fullData.resultHeaderTitles.name}</th>
                                <th className="gendercolumn">{fullData.resultHeaderTitles.gender}</th>
                                <th className="meaningcolumn">{fullData.resultHeaderTitles.meaning}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                similarBabyNames.map((data, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="namecolumn">
                                                { data.name }
                                            </td>
                                            <td className="gendercolumn">
                                            {                                            
                                                <GenderList key={index*Math.random(.5)}  icons={fullData.genderList} data={data.gender} />
                                            }
                                            </td>
                                            <td className="meaningcolumn">{data.meaning}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    {
                        (props.paginationData !== null && props.paginationData.totalCount > props.paginationData.itemsPerPage)  && 
                        <Pagination
                            //hideDisabled
                            firstPageText='first'
                            lastPageText='last'
                            activePage={currentPage}
                            itemsCountPerPage={props.paginationData.itemsPerPage}
                            totalItemsCount={props.paginationData.totalCount} 
                            pageRangeDisplayed={3}
                            onChange={paginate}
                        />
                    }
                </div>
            </React.Fragment>            
        )
    }    

}

export default NameResults
